
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({
    template: `@if (params.value > 0) {<a (click)='invokeClickAction()'>{{params.value}}</a>}@if (params.value <= 0) {<span>{{params.value}}</span>}`,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [],
})
export class PxdAgGridActionLinkComponent implements AgRendererComponent {
  params: any;
  id: any;

  agInit(params: any): void {
    this.params = params;

    if (this.params.id && this.params.data) {
      this.id = this.params.data[this.params.id];
    }
    else {
      this.id = this.params.value;
    }
  }

  invokeClickAction() {
    if (this.params.callAction)
      this.params.callAction(this.id);
  }

  refresh(params: any): boolean {
    return false;
  }
}